import React, { ReactNode } from 'react';
import { Badge } from '../common/Badge';
import { Button } from '../common/Button';

interface ColumnHeaderProps {
  title: string;
  count: number;
  badgeVariant: 'warning' | 'info';
  borderColor: 'border-primary' | 'border-success';
  bulkAction?: {
    label: string;
    onClick: () => void;
    disabled: boolean;
    variant: 'success' | 'secondary';
  };
  showSort?: boolean;
  sortControls?: ReactNode;
}

export const ColumnHeader: React.FC<ColumnHeaderProps> = ({
  title,
  count,
  badgeVariant,
  borderColor,
  bulkAction,
  showSort,
  sortControls,
}) => {
  return (
    <div className={`flex flex-col gap-3 mb-4 pb-3 border-b-2 ${borderColor}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
          <Badge variant={badgeVariant} size="md">
            {count}
          </Badge>
        </div>
        {bulkAction && count > 0 && (
          <Button
            variant={bulkAction.variant}
            size="sm"
            onClick={bulkAction.onClick}
            disabled={bulkAction.disabled}
          >
            {bulkAction.label}
          </Button>
        )}
      </div>
      {/* Always render this div to maintain consistent height */}
      <div className="min-h-[2.5rem]">
        {showSort && sortControls}
      </div>
    </div>
  );
};
